
import { Form, Input } from "decorator-form";
import * as displayFragments from "./fragments/displayFragments";
import { ILayout } from "common/form/fields/layout/ILayoutType";
import { IFragmentLayoutConfig } from "core/components/FragmentLayout";
import { FragmentProvider } from "core/components/FragmentProvider";
import InputType from "common/form/InputType";

const userLayout = FragmentProvider.getLayoutInput({...displayFragments});

@Form({title: "Test Assignment"})
export default class TestAssignmentFormConfig {

	@Input({type: userLayout, title: "Layout"})
	public userLayout: ILayout<IFragmentLayoutConfig>;

	@Input({type: InputType.NUMBER_POSITIVE, title: "Default Page Size"})
	public defaultPageSize: number;
}



// WEBPACK FOOTER //
// ./src/panels/testAssignment/TestAssignmentListConfig.ts